const guards = [];

const guard = async function(to, from, next) {
  let lastArgs = undefined;
  for (let i = 0; i < guards.length; i++) {
    const guard = guards[i];
    await guard.fn(to, from, args => {
      lastArgs = args;
    });

    if (lastArgs !== undefined) {
      break;
    }
  }

  if (!lastArgs) {
    return next();
  }

  next(lastArgs);
};

guard.add = function(guard, config) {
  const defaultConfig = { name: null };
  guards.push(Object.assign({}, defaultConfig, config, { fn: guard }));
};

export default guard;
